module.exports = __webpack_public_path__ + "images/bcac5a75e2ca70f335f96ff12e3a6874.png";